import classNames from 'classnames';

export type CTAColorVariant =
  | 'primary-blue'
  | 'primary-yellow'
  | 'spark-yellow'
  | 'primary-black'
  | 'secondary'
  | 'text-link'
  | 'aa-primary-blue'
  | 'aa-secondary'
  | 'aa-text-link';

// Base CTA Classes
export const baseCtaClasses = classNames(
  'cta__button',
  'block rounded-full font-bold lg:w-fit'
);

// Size Classes
export const getSizeClasses = (size: 'default' | 'thin' | 'aa') => {
  switch (size) {
    case 'default':
      return 'py-3 px-6';
    case 'thin':
      return 'py-2 px-6 text-sm';
    case 'aa':
      return 'py-[11px] px-6 text-lg';
  }
};

// Text Link Classes
export const getTextLinkAAClasses = () => {
  return 'font-medium underline text-dark-grey-1';
};

export const getTextLinkDefaultClasses = () => {
  return 'font-medium underline text-black hover:font-bold focus:border focus:border-grey-3 focus:rounded';
};

// Color Variant Classes
export const getColorClasses = (variant: CTAColorVariant) => {
  switch (variant) {
    case 'primary-blue':
      return 'bg-digital-walmart-blue text-white hover:bg-medium-blue focus:bg-dark-blue';
    case 'primary-black':
      return 'bg-black text-white hover:bg-grey-4 focus:bg-grey-3';
    case 'primary-yellow':
      return 'bg-sunrise-yellow text-ozark-noir hover:bg-light-yellow focus:bg-lighter-yellow';
    case 'spark-yellow':
      return 'bg-spark-yellow text-ozark-noir hover:bg-light-yellow focus:bg-lighter-yellow';
    case 'secondary':
      return 'bg-white text-black hover:shadow-[0_0_0_2px_black] focus:bg-black focus:text-white';
    case 'text-link':
      return 'font-medium underline';
    case 'aa-primary-blue':
      return 'bg-digital-walmart-blue text-white hover:bg-medium-blue focus:bg-dark-blue';
    case 'aa-secondary':
      return 'bg-white text-black shadow-[0_0_0_1px_black] hover:shadow-[0_0_0_2px_black] focus:shadow-[0_0_0_2px_black]';
    case 'aa-text-link':
      return 'font-medium underline';
  }
};
